// Dynamic viewport height fix for mobile browsers with collapsing address bars
// Sets CSS variable --dvh to the current visual viewport height in pixels.

function setDvh() {
  try {
    const vv = (window as any).visualViewport;
    const fallbackHeight = Math.max(
      Number(window.innerHeight || 0),
      Number(document.documentElement?.clientHeight || 0),
      Number(document.body?.clientHeight || 0),
      320,
    );
    const rawHeight = Number(vv?.height ?? fallbackHeight);
    const rawOffsetTop = Number(vv?.offsetTop ?? 0);

    let height = Number.isFinite(rawHeight) && rawHeight > 0 ? rawHeight : fallbackHeight;
    if (fallbackHeight >= 480 && height < 240) {
      height = fallbackHeight;
    }

    const offsetTop = Number.isFinite(rawOffsetTop) && rawOffsetTop >= 0 && rawOffsetTop < fallbackHeight
      ? rawOffsetTop
      : 0;

    document.documentElement.style.setProperty('--dvh', `${Math.round(height)}px`);
    document.documentElement.style.setProperty('--vv-offset-top', `${Math.round(offsetTop)}px`);
  } catch {
    // no-op
  }
}

export function initDynamicVH() {
  let raf: number | null = null;
  let burstUntil = 0;

  const burst = (ms = 900) => {
    burstUntil = Math.max(burstUntil, performance.now() + ms);
    if (raf !== null) return;
    const tick = () => {
      setDvh();
      if (performance.now() < burstUntil) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    };
    raf = requestAnimationFrame(tick);
  };

  burst(900);

  const onResize = () => burst(500);
  const onFocus = () => burst(900);

  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });
  (window as any).visualViewport?.addEventListener('resize', onResize, { passive: true } as any);
  (window as any).visualViewport?.addEventListener('scroll', onResize, { passive: true } as any);
  // iOS keyboards don't always dispatch reliable resize events in WebView;
  // while the keyboard animates, visualViewport.height often changes per-frame.
  document.addEventListener('focusin', onFocus);
  document.addEventListener('focusout', onFocus);
}

if (typeof window !== 'undefined') {
  // Initialize eagerly on load
  try { initDynamicVH(); } catch {}
}
